import { I18n } from 'aws-amplify/utils';

import en from '@/locale/en';
import jp from '@/locale/jp';

I18n.putVocabularies({en,jp});

I18n.setLanguage('jp');

export default I18n;